import data from "../../../configs/data";
import {Button} from "../../../controlElements/Button";
import {EuropeanRoulette} from "../../../EuropeanRoulette";
import {Utils} from "../../../Utils";

export class StraightBetsPanel extends PIXI.Container {

    private subscribers: Array<Function> = [];
    private buttons: Array<Button> = [];
    private disabledNumbers: Array<number>;

    constructor(buttonsOffsetX: number, buttonsOffsetY: number, offsetFromZero: number) {
        super();
        this.createAndAddZeroStraightBetButton(buttonsOffsetY);
        this.createAndAddBetsButtons(buttonsOffsetX, buttonsOffsetY, offsetFromZero);
    }

    public subscribeOnClicked(subscriber: Function): void {
        this.subscribers.push(subscriber);
    }

    public enableHighlightAndDisableButtons(numbers: Array<number>): void {
        this.disableHighlightAndEnableButtons(numbers, true);
        this.disabledNumbers = numbers;
        for (let i = 0; i < numbers.length; i++) {
            this.buttons[numbers[i]].enabled = false;
        }
    }

    public disableHighlightAndEnableButtons(numbers: Array<number>, force: boolean = false): void {
        if (Utils.areArraysOfNumbersSame(this.disabledNumbers, numbers) || force) {
            this.disabledNumbers = undefined;
            for (let i = 0; i < this.buttons.length; i++) {
                this.buttons[i].enabled = true;
            }
        }
    }

    public getButtonPosition(number: number): PIXI.Point {
        return (this.buttons[number].position as PIXI.Point);
    }

    private onValueChosen(value: number): void {
        for (let i = 0; i < this.subscribers.length; i++) {
            this.subscribers[i](value);
        }
    }

    private createAndAddBetsButtons(buttonsOffsetX: number, buttonsOffsetY: number,
                                    offsetFromZero: number): void {
        let columnCurrentIndex = 0;
        for (let numberValue = 1; numberValue <= EuropeanRoulette.ROULETTE_MAXIMUM_NUMBER; numberValue++) {
            const row = 2 - ((numberValue - 1) % 3);
            const button = new Button(data.images.regularNumberBaseState, data.images.regularNumberHoverDisableState,
                data.images.regularNumberHoverDisableState, data.images.regularNumberHoverDisableState);

            button.subscribeOnClicked(this.onValueChosen.bind(this, numberValue));
            button.position.x = offsetFromZero + columnCurrentIndex * buttonsOffsetX;
            button.position.y = row * buttonsOffsetY;
            this.buttons.push(button);
            this.addChild(button);
            if (row === 0) {
                columnCurrentIndex++;
            }
        }
    }

    private createAndAddZeroStraightBetButton(buttonsOffsetY: number): void {
        const button = new Button(data.images.zeroNumberBaseState, data.images.zeroNumberHoverDisableState,
            data.images.zeroNumberHoverDisableState, data.images.zeroNumberHoverDisableState);

        button.subscribeOnClicked(this.onValueChosen.bind(this, 0));
        button.position.y = buttonsOffsetY;
        this.buttons.push(button);
        this.addChild(button);
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/rouletteBetsPanel/implementations/StraightBetsPanel.ts